import { API_RETRY_COUNT, API_RETRY_DELAY_MS } from '../constants';

export async function fetchWithRetry<T>(
    fetchFn: () => Promise<T>,
    retries: number = API_RETRY_COUNT,
    delayMs: number = API_RETRY_DELAY_MS,
    operationName: string = 'API call'
): Promise<T> {
    let lastError: Error | null = null;

    for (let attempt = 1; attempt <= retries; attempt++) {
        try {
            const result = await fetchFn();
            return result;
            // TODO 200 err
        } catch (error) {
            lastError = error as Error;
            console.warn(
                `[Retry] ${operationName}: Failed attempt ${attempt}/${retries}`,
                error
            );

            if (attempt < retries) {
                const delay = delayMs * attempt;
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
    }

    console.error(
        `[Retry] ${operationName}: All ${retries} attempts failed`,
        lastError
    );
    throw new Error(
        `${operationName} failed after ${retries} attempts: ${lastError?.message}`
    );
}